import React from 'react';
import { styled } from '@mui/material';
import { AccountBalance } from '@mui/icons-material';
import { Colors } from 'library';
import { RStack, RText } from 'recruit/components';
import { PaymentMethod, isBankAccount } from './types';

interface PaymentMethodBadgeProps {
    method: PaymentMethod;
}

const BRAND_LABELS: Record<string, string> = {
    mastercard: 'MC',
};

function brandLabel(brand: string | null): string {
    const key = (brand || 'card').toLowerCase();
    return BRAND_LABELS[key] ?? key.toUpperCase().slice(0, 4);
}

export function PaymentMethodBadge({ method }: PaymentMethodBadgeProps) {
    if (isBankAccount(method)) {
        return (
            <Badge>
                <AccountBalance sx={{ fontSize: 18, color: Colors.darkNavy }} />
            </Badge>
        );
    }
    return (
        <Badge>
            <RText size="sm" weight="semibold" align="center">
                {brandLabel(method.brand)}
            </RText>
        </Badge>
    );
}

const Badge = styled(RStack)({
    width: 56,
    height: 36,
    borderRadius: 6,
    flexShrink: 0,
    backgroundColor: Colors.lightGrey,
    justifyContent: 'center',
    alignItems: 'center',
});
